import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../../util/theme";
import { Spacer } from "../../../layout";
import { datePickerTheme } from "./datePickerTheme";

interface DatePickerFooterProps {
    themeMode: RequiredThemeKeys;
}

const shouldForwardProp = (propName: string) => {
    switch (propName) {
        case "themeMode":
            return false;
        default:
            return true;
    }
};

export const DatePickerFooter = styled(Spacer, { shouldForwardProp })<DatePickerFooterProps>`
    justify-content: center;
    margin-top: ${({ themeMode }) => datePickerTheme.footer.marginTop(themeMode)};
`;
